/**
 * Desktop "import photos" screen. Layout only : a header (blue title + subtitle), the received-photos
 * grid, a centered white waiting card and a white footer bar with the status line + "Quitter" /
 * "Importer (N)" actions. The state logic lives in the shared
 * base (shared.panels.SelectPhotosPanelBase). See sass/.../desktop/common/SelectPhotosPanel.scss.
 */
fx.ns("desktop.common.panels", class SelectPhotosPanel extends shared.panels.SelectPhotosPanelBase {

	create()
	{
		super.create();

		// header : blue title and subtitle
		this.title = new fx.components.Text({ text : "", className : "title" });
		this.addChild(this.title, { top : 40, left : 56, width : 760 });

		this.subtitle = new fx.components.Text({ text : "", className : "subtitle" });
		this.addChild(this.subtitle, { top : 76, left : 56, width : 760 });

		// the photos, between the header and the footer bar : big square tiles that wrap instead of
		// shrinking (maxElementsPerRow "auto"). left:49 + right:49 (both margins, no width) : stretches
		// between them, so the 7px tile inset lands the content at 56 on both sides (header-aligned).
		this.grid = this._createGrid(190, "auto");
		this.addChild(this.grid, { top : 132, left : 49, right : 49, bottom : 98 });

		// waiting state : a centered white card (phone illustration, spinner + label, hint)
		this.empty = new fx.components.Text({ className : "empty", text : this._emptyContent() });
		this.empty.visibleAtStart = false;
		this.addChild(this.empty, { top : "center", left : "center", width : 560, height : 384 });

		// the reception progress, full width, right above the footer
		this.progress = this._createProgress();
		this.addChild(this.progress, { left : 0, width : "fill", bottom : 92, height : 6 });

		// white footer bar : status line on the left, "Quitter" and the "Importer (N)" call to action
		this.footerBar = new fx.components.Box("footer-bar");
		this.addChild(this.footerBar, { left : 0, width : "fill", bottom : 0, height : 92 });

		this.footerInfo = new fx.components.Text({ text : "", className : "footer-info" });
		this.addChild(this.footerInfo, { left : 56, bottom : 36 });

		this.validateBtn = new fx.components.Button({ label : fx.text(this._buttonLabel, this.count), type : "filled", className : "importBtn" });
		this.addChild(this.validateBtn, { right : 56, bottom : 20, width : 180, height : 52 });

		this.exitBtn = new fx.components.Button({ label : fx.text("Quitter"), className : "exitBtn" });
		this.addChild(this.exitBtn, { right : 248, bottom : 20, width : 120, height : 52 });

		this._update();
	}
});
